<script>
export default {
  name: 'CustomerTrackingSocietyGuide',
  props: ['show'],
};
</script>

<template>
  <v-dialog :value="show" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Guión de llamadas para sociedades</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="$emit('close')">Cerrar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text style="padding-top: 0" class="society-guide">
        <div class="llamada">
          <h2>
            <span class="emoji">📞</span>
            Primera llamada del año – Evaluación y necesidades de la empresa
          </h2>

          <div class="objetivo">
            <h3>
              <span class="emoji">🎯</span>
              Objetivo:
            </h3>
            <ul>
              <li>Evaluar la experiencia con la asesoría y detectar áreas de mejora.</li>
              <li>Conocer la situación actual de la empresa y posibles cambios estratégicos.</li>
              <li>Ofrecer asesoramiento fiscal, contable y laboral adaptado a sus necesidades.</li>
            </ul>
          </div>

          <div class="seccion">
            <h3>
              <span class="emoji">📜</span>
              Guion de la llamada:
            </h3>

            <ol>
              <li>
                <p class="destacado">Introducción</p>
                <p>
                  "Hola [nombre del contacto], soy [tu nombre] de OpenGes. Quería llamarte porque en
                  OpenGes estamos reforzando nuestro acompañamiento a empresas como la tuya. Nos
                  gustaría saber cómo ha ido el negocio en estos últimos meses y ver cómo podemos
                  ayudarte a optimizar la gestión fiscal, contable y laboral. ¿Tienes unos minutos
                  para charlar?"
                </p>
                <p><em>Si el cliente está ocupado:</em></p>
                <p>"No hay problema, dime cuándo te viene mejor y te llamo en otro momento."</p>
              </li>

              <li>
                <p class="destacado">Preguntas clave para entender la situación de la empresa</p>
                <ul>
                  <li>¿Cómo ha evolucionado la empresa en estos últimos meses?</li>
                  <li>
                    ¿Tenéis prevista alguna inversión o expansión que requiera planificación fiscal
                    o financiera?
                  </li>
                  <li>
                    ¿Estáis satisfechos con la información y asesoramiento que os proporcionamos?
                    ¿Hay algo que os gustaría mejorar?
                  </li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Asesoramiento y valor añadido</p>
                <ul>
                  <li>Optimización fiscal: Estrategias para reducir la carga tributaria.</li>
                  <li>Subvenciones y ayudas: Oportunidades según su sector y situación.</li>
                  <li>
                    Digitalización y automatización contable: Revisión de herramientas que pueden
                    facilitar la gestión. (clave de consulta de movimientos bancarios, aclaraciones
                    partidas pendientes, facturas pendientes de enviar)
                  </li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Preguntas clave sobre el servicio prestado por OpenGes</p>
                <ul>
                  <li>¿Cómo ha sido tu experiencia con nuestro servicio en los últimos meses?</li>
                  <li>
                    ¿Sientes que tienes toda la información y apoyo que necesitas en el área fiscal
                    o contable?
                  </li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Cierre y próximos pasos</p>
                <p>
                  "Gracias por tu tiempo, [nombre]. Me llevo anotado [resumen de necesidades o temas
                  clave] y vamos a [acción que tomará la asesoría]. Si surge algo más, estamos aquí
                  para ayudaros. ¡Seguimos en contacto!"
                </p>
              </li>
            </ol>
          </div>
        </div>

        <div class="llamada">
          <h2>
            <span class="emoji">📞</span>
            Segunda llamada del año – Seguimiento y planificación estratégica
          </h2>

          <div class="objetivo">
            <h3>
              <span class="emoji">🎯</span>
              Objetivo:
            </h3>
            <ul>
              <li>Hacer seguimiento de los temas tratados en la primera llamada.</li>
              <li>Ayudar a la empresa en la planificación fiscal y financiera de cierre de año.</li>
              <li>Informar sobre novedades legales y oportunidades relevantes.</li>
            </ul>
          </div>

          <div class="seccion">
            <h3>
              <span class="emoji">📜</span>
              Guion de la llamada:
            </h3>

            <ol>
              <li>
                <p class="destacado">Introducción</p>
                <p>
                  "Hola [nombre del contacto], soy [tu nombre] de OpenGes. Hace unos meses hablamos
                  sobre [tema tratado en la primera llamada] y quería saber cómo ha evolucionado la
                  situación. También quería comentarte algunas novedades fiscales que pueden afectar
                  a la empresa y ver si podemos ayudaros con la planificación de cierre de año.
                  ¿Tienes un momento?"
                </p>
                <p><em>Si no hubo temas pendientes:</em></p>
                <p>
                  "Quería hablar contigo porque estamos ayudando a nuestros clientes a optimizar su
                  cierre fiscal y contable del año, y quería revisar si podemos hacer algún ajuste
                  en vuestra planificación para reducir costes o aprovechar oportunidades."
                </p>
              </li>

              <li>
                <p class="destacado">Preguntas clave para el cierre del año</p>
                <ul>
                  <li>
                    ¿Se han producido cambios en la facturación o beneficios que puedan afectar la
                    tributación?
                  </li>
                  <li>
                    ¿Cómo estáis gestionando los impuestos y pagos fraccionados? ¿Queréis revisar la
                    previsión fiscal? Ver posible cambio al artículo 40.3 LIS para los pagos
                    fraccionados del año que viene.
                  </li>
                  <li>
                    ¿Tenéis previsto realizar inversiones que puedan beneficiarse de deducciones
                    fiscales? I+D+I, inversiones en espectáculos, amortización acelerada bienes de
                    inversión.
                  </li>
                  <li>
                    ¿Habéis revisado si podéis aplicar alguna bonificación en Seguridad Social o
                    deducciones en el Impuesto de Sociedades?
                  </li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Información de valor</p>
                <ul>
                  <li>Cambios en normativas fiscales y contables que afecten a la empresa.</li>
                  <li>Estrategias para optimizar el Impuesto de Sociedades.</li>
                  <li>Revisión de subvenciones y ayudas disponibles.</li>
                  <li>
                    Recomendaciones para la gestión de la tesorería y optimización de cash flow.
                  </li>
                  <li>Seguros de responsabilidad civil, accidente, vehículos.</li>
                  <li>Retribución socios/administradores.</li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Cierre y próximos pasos</p>
                <p>
                  "Me alegro de haber podido ponerte al día, [nombre]. Me quedo con [resumen de
                  puntos clave]. Si necesitas que revisemos algo más en detalle, dime y lo vemos
                  juntos. ¡Un placer hablar contigo!"
                </p>
              </li>
            </ol>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.society-guide {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
h1 {
  color: #2c3e50;
  border-bottom: 2px solid #3498db;
  padding-bottom: 10px;
}
h2 {
  color: #2980b9;
  margin-top: 30px;
}
.llamada {
  background-color: #f8f9fa;
  border-left: 4px solid #3498db;
  padding: 15px;
  margin-bottom: 30px;
  border-radius: 0 5px 5px 0;
}
.objetivo {
  background-color: #e8f4f8;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.objetivo h3 {
  margin-top: 0;
  color: #2980b9;
}
.objetivo ul {
  margin-bottom: 0;
}
.seccion {
  margin-bottom: 20px;
}
.seccion h3 {
  color: #2c3e50;
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
}
.seccion ol {
  padding-left: 20px;
}
.seccion ul {
  list-style-type: circle;
  padding-left: 20px;
}
.destacado {
  font-weight: bold;
  color: #2980b9;
}
.emoji {
  font-size: 1.5em;
  margin-right: 10px;
  vertical-align: middle;
}
</style>
